/* Progressive enhancement: unanimated content stays readable without JS.
   Existing section reveals and product/sticker transforms keep ownership. */
(function () {
  'use strict';

  function parseMetric(text) {
    var match = text.trim().match(/^([+<>≤≥~]?\s*)(\d{1,3}(?:,\d{3})+|\d+)([^\d]*)$/);
    if (!match || /[$€\/]/.test(text)) return null;
    var target = Number(match[2].replace(/,/g, ''));
    if (!Number.isFinite(target) || target < 1 || target > 100000000) return null;
    return { target: target, prefix: match[1], suffix: match[3], grouped: match[2].indexOf(',') !== -1, final: text.trim() };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { parseMetric: parseMetric };
    return;
  }
  if (window.KexSmoothIntro) { window.KexSmoothIntro.scan(); return; }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var owned = '[data-kx-reveal],[data-cc-animate],[data-pumpkin-reveal]';
  var blocked = 'dialog,[role="dialog"],header-group,nav,[data-no-kex-intro],.drawer,.modal,.quick-add,.sticky-atc-panel';
  var cards = '.kexsup__metric,.kexbiz__metric,.kexv-metric,.kexpumpkin__metrics > div,.kexs-service';
  var numbers = '.kexsup__metric strong,.kexbiz__metric strong,.kexv-metric strong,.kexpumpkin__metrics strong';
  var sections = 'main .shopify-section,main section,main header,main > article,main > .shopify-policy__container,main .kex-seasonal__link,main .kex-seasonal__closing,.shopify-section-group-footer-group';
  var targets = new Map();
  var counters = new Map();
  var animations = new Map();
  var queued = false;
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(onIntersection, {
    threshold: 0, rootMargin: '0px 0px -24px 0px'
  }) : null;

  function excluded(el) {
    if (el.closest(blocked)) return true;
    var style = getComputedStyle(el);
    return style.position === 'fixed' || style.position === 'sticky';
  }

  function finishIntro(el) {
    var animation = animations.get(el);
    if (animation) { animations.delete(el); animation.cancel(); }
    el.dataset.kexIntro = reduced.matches ? 'reduced' : 'done';
  }

  function enter(el) {
    var info = targets.get(el);
    if (!info || info.started) return;
    info.started = true;
    if (observer) observer.unobserve(el);
    // Another theme script may have attached its reveal after our first scan.
    if (reduced.matches || !el.animate || el.matches(owned) || el.parentElement.closest(owned)) {
      finishIntro(el);
      return;
    }
    el.dataset.kexIntro = 'running';
    try {
      var style = getComputedStyle(el);
      var frames = [{ opacity: 0 }, { opacity: style.opacity }];
      // Individual translate leaves CSS transform-based floating/hover intact.
      if (style.translate === 'none' || !style.translate) {
        frames[0].translate = '0 ' + (innerWidth <= 749 ? 14 : 22) + 'px';
        frames[1].translate = '0 0';
      }
      var animation = el.animate(frames, {
        duration: 760, delay: info.delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'
      });
      animations.set(el, animation);
      animation.finished.then(function () { finishIntro(el); }, function () {});
    } catch (error) { finishIntro(el); }
  }

  function finishCounter(el, info) {
    if (info.frame) cancelAnimationFrame(info.frame);
    info.frame = 0;
    if (info.visual) {
      info.visual.textContent = info.metric.final;
      info.visual.style.minWidth = '';
    }
    el.dataset.kexCountState = 'done';
  }

  function count(el) {
    var info = counters.get(el);
    if (!info || info.started) return;
    info.started = true;
    if (observer) observer.unobserve(el);
    if (reduced.matches) { finishCounter(el, info); return; }
    var range = document.createRange();
    range.selectNodeContents(el);
    var width = range.getBoundingClientRect().width;
    var spoken = document.createElement('span');
    spoken.className = 'visually-hidden';
    spoken.textContent = info.metric.final;
    var visual = document.createElement('span');
    visual.setAttribute('aria-hidden', 'true');
    visual.style.display = 'inline-block';
    visual.style.font = 'inherit';
    visual.style.color = 'inherit';
    visual.style.letterSpacing = 'inherit';
    visual.style.lineHeight = 'inherit';
    visual.style.minWidth = Math.ceil(width) + 'px';
    el.replaceChildren(spoken, visual);
    info.visual = visual;
    el.dataset.kexCountState = 'running';
    var start = performance.now();
    function step(now) {
      if (reduced.matches || !el.isConnected) { finishCounter(el, info); return; }
      var progress = Math.min(1, (now - start) / 1250);
      var value = Math.round(info.metric.target * (1 - Math.pow(1 - progress, 3)));
      visual.textContent = info.metric.prefix + (info.metric.grouped ? value.toLocaleString('es-MX') : value) + info.metric.suffix;
      if (progress < 1) info.frame = requestAnimationFrame(step);
      else finishCounter(el, info);
    }
    step(start);
  }

  function onIntersection(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      if (targets.has(entry.target)) enter(entry.target);
      if (counters.has(entry.target)) count(entry.target);
    });
  }

  function register(el, delay) {
    if (targets.has(el) || excluded(el) || el.closest(owned)) return;
    if (el.parentElement.closest('[data-kex-intro="ready"],[data-kex-intro="running"]')) return;
    // A section whose children already reveal must not animate a second wrapper.
    if (el.querySelector(owned + ',[data-kex-intro]')) return;
    targets.set(el, { delay: delay || 0, started: false });
    el.dataset.kexIntro = 'ready';
    if (reduced.matches || !observer) enter(el);
    else observer.observe(el);
  }

  function scan() {
    queued = false;
    targets.forEach(function (_, el) {
      if (!el.isConnected) { if (observer) observer.unobserve(el); finishIntro(el); targets.delete(el); }
    });
    counters.forEach(function (info, el) {
      if (!el.isConnected) { if (observer) observer.unobserve(el); finishCounter(el, info); counters.delete(el); }
    });
    var main = document.querySelector('main');
    if (!main) return;
    main.querySelectorAll(cards).forEach(function (card) {
      var siblings = Array.from(card.parentElement.children).filter(function (el) { return el.matches(cards); });
      register(card, Math.min(siblings.indexOf(card), 3) * 90);
    });
    main.querySelectorAll(numbers).forEach(function (el) {
      if (counters.has(el) || el.querySelector('[data-kx-count]') || el.hasAttribute('data-kx-count') || excluded(el)) return;
      var metric = parseMetric(el.textContent);
      if (!metric || el.children.length) return;
      counters.set(el, { metric: metric, started: false, frame: 0 });
      el.dataset.kexCountFinal = metric.final;
      el.dataset.kexCountState = 'ready';
      if (reduced.matches || !observer) count(el);
      else observer.observe(el);
    });
    Array.from(document.querySelectorAll(sections)).reverse().forEach(function (section) {
      register(section, 0);
    });
    document.documentElement.dataset.kexSmoothIntro = 'ready';
  }

  function queue() {
    if (queued) return;
    queued = true;
    // Let the existing home/section decorators claim their own elements first.
    requestAnimationFrame(function () { requestAnimationFrame(scan); });
  }

  function boot() {
    queue();
    var main = document.querySelector('main');
    if (main && 'MutationObserver' in window) {
      new MutationObserver(function (records) {
        if (records.some(function (record) {
          return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) { return node.nodeType === 1; });
        })) queue();
      }).observe(main, { childList: true, subtree: true });
    }
  }

  reduced.addEventListener('change', function () {
    if (reduced.matches) {
      targets.forEach(function (_, el) { enter(el); finishIntro(el); });
      counters.forEach(function (info, el) { info.started = true; if (observer) observer.unobserve(el); finishCounter(el, info); });
    } else queue();
  });
  document.addEventListener('focusin', function (event) {
    var el = event.target.closest('[data-kex-intro]');
    if (el && targets.has(el)) { enter(el); finishIntro(el); }
  });
  document.addEventListener('shopify:section:load', queue);
  document.addEventListener('shopify:section:select', function (event) {
    queue();
    event.target.querySelectorAll('[data-kex-intro]').forEach(function (el) { enter(el); finishIntro(el); });
  });
  window.addEventListener('pageshow', queue);
  window.KexSmoothIntro = { scan: queue };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
